module.exports = __webpack_public_path__ + "img/ens.5b89874b.svg";